import { useCachedSsrRef } from "./serverCache.mjs";
import { useSetLocaleToCacheParams } from "./i18n.mjs";
import { StoreConfigDocument } from "../graphql/Config.mjs";
import { CountryCodeEnum } from "../graphql/graphql-types.gen.mjs";
import { CONFIG_STORE_COUNTRY, CONFIG_STORE_CURRENCY } from "../utils/provides.mjs";
import { computed, provide, ref } from "vue";
import { useQuery } from "villus";
import { useAsyncData } from "#app";
const DEFAULT_STORE_PICKUP = false;
export function useStoreConfig() {
  const { cacheParam } = useSetLocaleToCacheParams();
  const state = useCachedSsrRef(cacheParam("store-config"), {
    currencyCode: null,
    defaultTitle: null,
    defaultDescription: null,
    defaultKeywords: null,
    title_prefix: null,
    title_suffix: null,
    initialized: false,
    limited_qty_threshold: null,
    enableStorePickup: DEFAULT_STORE_PICKUP
  });
  const { error, execute } = useQuery({
    query: StoreConfigDocument.toString(),
    fetchOnMount: false
  });
  const { data } = useAsyncData(async () => {
    if (state.value.initialized) {
      return state.value;
    }
    const { data: data2 } = await execute();
    if (error.value) {
      throw new Error(error.value.message);
    }
    state.value = {
      currencyCode: data2?.storeConfig?.base_currency_code,
      defaultTitle: data2?.storeConfig?.default_title,
      defaultDescription: data2?.storeConfig?.default_description,
      defaultKeywords: data2?.storeConfig?.default_keywords,
      title_prefix: data2?.storeConfig?.title_prefix,
      title_suffix: data2?.storeConfig?.title_suffix,
      initialized: true,
      limited_qty_threshold: data2?.storeConfig?.limited_qty_threshold,
      enableStorePickup: DEFAULT_STORE_PICKUP
    };
    return state.value;
  });
  const refs = {
    currencyCode: computed(() => data.value?.currencyCode),
    defaultTitle: computed(() => data.value?.defaultTitle),
    defaultDescription: computed(() => data.value?.defaultDescription),
    defaultKeywords: computed(() => data.value?.defaultKeywords),
    title_prefix: computed(() => data.value?.title_prefix),
    title_suffix: computed(() => data.value?.title_suffix),
    initialized: true,
    limited_qty_threshold: computed(() => data.value?.limited_qty_threshold),
    enableStorePickup: computed(() => data.value?.enableStorePickup)
  };
  provide(CONFIG_STORE_CURRENCY, ref(refs.currencyCode.value || "EGP"));
  provide(CONFIG_STORE_COUNTRY, CountryCodeEnum.Eg);
  return {
    ...refs
  };
}
